import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Le thème par défaut est "sombre"
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "sombre");

  useEffect(() => {
    // On applique l'attribut data-theme sur l'élément racine (html)
    document.documentElement.setAttribute("data-theme", theme);
    // On sauvegarde le choix de l'utilisateur
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "sombre" ? "clair" : "sombre"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);